
import { AutoMap } from "@automapper/classes";
import { ELIMSTest } from "./ELIMS/ELIMS-test";
import { EComparaisonLQ } from "./enum/comparaison-lq";
import { Limit } from "./limit";

export class Test {
    public constructor(init?: Partial<Test>) {
        Object.assign(this, init);
    }

    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = ''
    @AutoMap()
    ElimsUnitName: string = ''
    @AutoMap()
    DisplayedUnitName: string = ''
    @AutoMap()
    Position: number = 1;
    @AutoMap()
    ComparaisonLQ: EComparaisonLQ = EComparaisonLQ.LQ;
    @AutoMap(() => ELIMSTest)
    ElimsTestList: ELIMSTest[] = [];
    @AutoMap(() => Limit)
    LimitList: Limit[] = [];
    @AutoMap()
    IsSum: boolean = false;

    // static mapFromJSON(json: any): Test {
    //     const t = new Test();

    //     t.Code = json.code
    //     t.Name = json.name
    //     t.Position = json.position
    //     t.ElimsUnitName = json.elimsUnitName
    //     t.DisplayedUnitName = json.displayedUnitName
    //     t.ComparaisonLQ = json.comparaisonLQ;
    //     t.IsSum = json.isSum;

    //     if (json.elimsTestList) {
    //         t.ElimsTestList = json.elimsTestList.map((item: any) => ELIMSTest.mapFromJSON(item));
    //     }
    //     if (json.limitList) {
    //         t.LimitList = json.limitList.map((item: any) => Limit.mapFromJSON(item));
    //     }
    //     return t;
    // }
}